// extracted by mini-css-extract-plugin
module.exports = {"root":"BoxColumnTariff_root__2Buh_","formItem":"BoxColumnTariff_formItem__-okDZ","containerTarrifs":"BoxColumnTariff_containerTarrifs__2Bxti"};